// extracted by mini-css-extract-plugin
export default {"bannerContainer":"styles_bannerContainer__XtZij","bannerImage":"styles_bannerImage__nSI8M"};